import { Injectable } from '@angular/core';
import { HamburgerMenuItem, TableContextMenuItem } from '@captiveaire/table';
import { IDeviceStatusListSummary } from '../models/device-status-list-summary.interface';
import { DeviceDetailViewComponent } from '../../device-detail-view/device-detail-view.component';
import { DeviceStatusGridComponent } from '../../device-status-grid/device-status-grid.component';

export const enum DeviceDetailViewMenuItem {
    Edit = 1,
    Save = 2,
    Cancel = 3
}


// tslint:disable:object-literal-sort-keys
@Injectable({
    providedIn: 'root'
})
export class DeviceMenuItemsService {
    public static $name = 'deviceMenuItemsFactory';

    public getMenuItems(component: DeviceStatusGridComponent | DeviceDetailViewComponent) {
        return {
            items: {
                viewDeviceDetail: {
                    icon: 'visibility',
                    label: 'View Module Editor',
                    method: ($event, item: IDeviceStatusListSummary) => {
                        component.viewDetail(item);
                    },
                    isVisible: (item) => {
                        return true;
                    },
                    isRowClickHandler: true
                } as any,
                editDeviceConfiguration: {
                    icon: 'edit',
                    isVisible: (item) => {
                        return !item.$isInEditMode;
                    },
                    label: 'Edit Device',
                    type: DeviceDetailViewMenuItem.Edit,
                    method: ($event, item) => {
                        (component as DeviceStatusGridComponent).editDeviceConfiguration(item);
                    }

                } as any,
                saveDeviceConfigurationEdits: {
                    icon: 'save',
                    isVisible: (item) => {
                        return item.$isInEditMode;
                    },
                    label: 'Save Device',
                    type: DeviceDetailViewMenuItem.Save,
                    method: ($event, item) => {
                        (component as DeviceStatusGridComponent).saveEdit(item);
                    }
                } as any,
                cancelDeviceConfigurationEdits: {
                    icon: 'cancel',
                    isVisible: (item) => {
                        return item.$isInEditMode;
                    },
                    label: 'Cancel Edit',
                    type: DeviceDetailViewMenuItem.Cancel,
                    method: ($event, item) => {
                        (component as DeviceStatusGridComponent).cancelEdit(item);
                    }
                } as any,
                viewDeviceJson: {
                    icon: 'settings_ethernet',
                    label: 'View Device JSON',
                    method: ($event, item) => {
                        component.viewJson(item);
                    },
                    isVisible: (item) => {
                        return !item.$isInEditMode;
                    }
                } as TableContextMenuItem,
                deleteDevice: {
                    icon: 'delete',
                    isVisible: (item: IDeviceStatusListSummary) => {
                        return !item.$isInEditMode && item.category !== 'module';
                    },
                    label: 'Delete Item',
                    method: ($event, item) => {
                        component.deleteDevice(item);
                    }
                } as TableContextMenuItem,
                changeTemplateVersion: {
                    label: 'Change Template Version',
                    icon: 'edit',
                    method: ($event, items) => {
                        (component as DeviceStatusGridComponent).changeTemplateVersion($event, items);
                    },
                    isVisible: (items) => {
                        return items != null && items.length > 0 && (component as DeviceStatusGridComponent).isFilterActive;
                    },
                    isHamburgerItem: true
                } as HamburgerMenuItem,
                refreshHwConfiguration: {
                    icon: 'autorenew',
                    isVisible: (item: IDeviceStatusListSummary) => {
                        return !item.$isInEditMode && item.category === 'module';
                    },
                    label: 'Refresh Hardware Configuration',
                    method: ($event, item) => {
                        component.deviceStatusService.refreshHardwareConfiguration(item);
                    }
                } as TableContextMenuItem,
                exportToXlsx: {
                    label: 'Export to XLSX',
                    icon: 'insert_drive_file',
                    method: ($event, items) => {
                        (component as DeviceStatusGridComponent).exportToXlsx();
                    },
                    isVisible: (items) => {
                        return items != null && items.length > 0;
                    },
                    isHamburgerItem: true
                } as HamburgerMenuItem,
                updateFirmwareVersion: {
                    label: 'Update Firmware Version',
                    icon: 'system_update_alt',
                    method: ($event, items) => {
                        (component as DeviceStatusGridComponent).updateFirmwareVersion($event);
                    },
                    isVisible: (items) => {
                        return items != null &&
                            items.length > 0 &&
                            (component as DeviceStatusGridComponent).isFilterActive &&
                            (component as DeviceStatusGridComponent).canUpdateFirmwareVersion;
                    },
                    isHamburgerItem: true
                } as HamburgerMenuItem,
                rotateEncryptionKeys: {
                    label: 'Rotate Encryption Keys',
                    icon: 'loop',
                    method: ($event, item: IDeviceStatusListSummary) => {
                        component.deviceStatusService.rotateEncryptionKeys(item.hardwareItem.id);
                    },
                    isVisible: (item) => {
                        return item != null && item.isScada && item.category === 'module';
                    }
                } as TableContextMenuItem,
                pingAgent: {
                    label: 'Ping Agent',
                    icon: 'swap_horizontal_circle',
                    method: ($event, item: IDeviceStatusListSummary) => {
                        component.deviceStatusService.pingAgent(item.hardwareItem.id);
                    },
                    isVisible: (item: IDeviceStatusListSummary) => {
                        return item != null && item.isScada && item.category === 'module';
                    }
                } as TableContextMenuItem,
                hardReboot: {
                    label: 'Hard Reboot',
                    icon: 'rotate_right',
                    method: ($event, item: IDeviceStatusListSummary) => {
                        component.deviceStatusService.hardReboot(item.hardwareItem.id);
                    },
                    isVisible: (item: IDeviceStatusListSummary) => {
                        return item != null && item.isScada && item.category === 'module';
                    }
                } as TableContextMenuItem,
                softReboot: {
                    label: 'Soft Reboot',
                    icon: 'update',
                    method: ($event, item: IDeviceStatusListSummary) => {
                        component.deviceStatusService.softReboot(item.hardwareItem.id);
                    },
                    isVisible: (item: IDeviceStatusListSummary) => {
                        return item != null && item.isScada && item.category === 'module';
                    }
                } as TableContextMenuItem,
                restartAgent: {
                    label: 'Restart Agent',
                    icon: 'rotate_left',
                    method: ($event, item: IDeviceStatusListSummary) => {
                        component.deviceStatusService.restartAgent(item.hardwareItem.id);
                    },
                    isVisible: (item: IDeviceStatusListSummary) => {
                        return item != null && item.isScada && item.category === 'module';
                    }
                } as TableContextMenuItem,
                restartApplication: {
                    label: 'Restart Application',
                    icon: 'rotate_90_degrees_ccw',
                    method: ($event, item: IDeviceStatusListSummary) => {
                        component.deviceStatusService.restartApplication(item.hardwareItem.id);
                    },
                    isVisible: (item: IDeviceStatusListSummary) => {
                        return item != null && item.isScada && item.category === 'module';
                    }
                } as TableContextMenuItem,
            },
            menuContext: 'deviceStatuses'
        };
    }
}
